import { render, staticRenderFns } from "./HoldConfirmModal.vue?vue&type=template&id=acc2286e"
import script from "./HoldConfirmModal.vue?vue&type=script&lang=js"
export * from "./HoldConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports